//FIX ORDER
import slimscroll from "jquery-slimscroll";

jQuery(document).ready(function () {

    window.myapp_config = require("./libs/_config/app.config.js");
    window.myapp_get_color = require("./libs/_get/app.get.colors.js");
    window.initApp = require("./libs/_init/app.init.js");

    require("./libs/_modules/app.domReady.js");
    require("./libs/_modules/app.orientationchange.js");
    require("./libs/_modules/app.resize.trigger.js");
    require("./libs/_modules/app.scroll.trigger.js");
    require("./libs/_modules/app.window.load.js");
    require("./libs/_modules/app.navigation.js");

});




